module.exports = __webpack_public_path__ + "img/login-v2.217bf2c1.svg";